import { FC } from "react";
import { WrotevoteReplyVoteModel } from "../../models/wrotevote/WrotevoteReplyVoteModel";
import { WrotevoteVotePercent } from "./WrotevoteVotePercent";
import { Reply } from "../Reply";

type Props = {
    model: WrotevoteReplyVoteModel;
    showUsername?: boolean;
    showPrompt?: boolean;
    showVotePercent?: boolean;
};

export const WrotevoteReplyVote: FC<Props> = (props: Props) => {
    const { model, showUsername, showPrompt, showVotePercent } = props;

    return (
        <div className="text-center">
            {showUsername && <p className="font-weight-bold">{model.User}</p>}

            {showPrompt && (
                <p>
                    <small>{model.Prompt}</small>
                </p>
            )}

            <Reply body={model.Body} />

            {showVotePercent && <WrotevoteVotePercent voteCount={model.VoteCount} votePercent={model.VotePercent} />}
        </div>
    );
};

WrotevoteReplyVote.defaultProps = {
    showUsername: true,
    showPrompt: true,
    showVotePercent: true,
};
